// Definicje sterowników dla wkładów Dragon
// Na podstawie zrzutów ekranu klienta

export const CONTROLLER_PRICES = {
  'none': 0,
  'rt-08-om': 1510,
  'rt-08-om-grafik': 1610,
  'rt-08-om-grafik-wb': 1745, // white/black - wybór koloru
  'rt-08-om-duo-integra': 2170,
  'rt-08-om-grafik-duo-integra': 2200,
  'rt-08-om-grafik-duo-integra-wb': 2300, // white/black - wybór koloru
  'czujnik-drzwiczek': 215
} as const

export const CONTROLLER_LABELS = {
  'none': 'Brak',
  'rt-08-om': 'RT-08 OM',
  'rt-08-om-grafik': 'RT-08 OM GRAFIK',
  'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
  'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
  'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
  'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK',
  'czujnik-drzwiczek': 'Czujnik drzwiczek'
} as const

// ====================================================================
// STEROWNIKI DLA WKŁADÓW NEMO - na podstawie zrzutów ekranu klienta
// ====================================================================

// Normalne sterowniki NEMO (z ZRZUTU 1)
export const NEMO_CONTROLLER_PRICES = {
  'none': 0,
  // RT-08 G (z opcją BUFOR - ta sama cena)
  'rt-08-g': 1440,
  // RT-08 G WHITE / BLACK (z opcją BUFOR - ta sama cena)
  'rt-08-g-wb': 1570,
  // RT-08 G X WHITE / BLACK (z opcją BUFOR - ta sama cena)
  'rt-08-g-x-wb': 2450,
  // Czujnik drzwiczek - tylko dla RT-08G X
  'czujnik-drzwiczek': 215
} as const

export const NEMO_CONTROLLER_LABELS = {
  'none': 'Brak',
  'rt-08-g': 'RT-08G TITANIUM',
  'rt-08-g-wb': 'RT-08G WHITE / BLACK',
  'rt-08-g-x-wb': 'RT-08GX WHITE / BLACK',
  'czujnik-drzwiczek': 'Czujnik drzwiczek'
} as const

// DUO INTEGRA sterowniki NEMO (z ZRZUTU 2)
export const NEMO_DUO_INTEGRA_CONTROLLER_PRICES = {
  // RT-08G DUO INTEGRA (z opcją BUFOR - ta sama cena)
  'rt-08-g-duo-integra': 1800,
  // RT-08G WHITE / BLACK DUO INTEGRA (z opcją BUFOR - ta sama cena)
  'rt-08-g-wb-duo-integra': 1850,
  // RT-08G X DUO INTEGRA (z opcją BUFOR - ta sama cena)
  'rt-08-g-x-duo-integra': 2400,
  // RT-08G X WHITE / BLACK DUO INTEGRA (z opcją BUFOR - ta sama cena)
  'rt-08-g-x-wb-duo-integra': 2450
} as const

export const NEMO_DUO_INTEGRA_CONTROLLER_LABELS = {
  'rt-08-g-duo-integra': 'RT-08 G DUO INTEGRA TITANIUM',
  'rt-08-g-wb-duo-integra': 'RT-08G DUO INTEGRA WHITE / BLACK',
  'rt-08-g-x-duo-integra': 'RT-08GX DUO INTEGRA TITANIUM',
  'rt-08-g-x-wb-duo-integra': 'RT-08GX DUO INTEGRA WHITE / BLACK'
} as const

// Połączone ceny dla wszystkich sterowników NEMO
export const NEMO_ALL_CONTROLLERS_PRICES = {
  ...NEMO_CONTROLLER_PRICES,
  ...NEMO_DUO_INTEGRA_CONTROLLER_PRICES
}

// Połączone etykiety dla wszystkich sterowników NEMO
export const NEMO_ALL_CONTROLLERS_LABELS = {
  ...NEMO_CONTROLLER_LABELS,
  ...NEMO_DUO_INTEGRA_CONTROLLER_LABELS
}

// Sterowniki NEMO które wymagają wyboru koloru (WHITE/BLACK)
export const NEMO_CONTROLLERS_WITH_COLOR = [
  'rt-08-g-wb',
  'rt-08-g-x-wb',
  'rt-08-g-wb-duo-integra',
  'rt-08-g-x-wb-duo-integra'
] as const

// Sterowniki NEMO które wspierają opcję BUFOR
export const NEMO_CONTROLLERS_WITH_BUFOR = [
  'rt-08-g',
  'rt-08-g-wb',
  'rt-08-g-x-wb',
  'rt-08-g-duo-integra',
  'rt-08-g-wb-duo-integra',
  'rt-08-g-x-duo-integra',
  'rt-08-g-x-wb-duo-integra'
] as const

// Sterowniki NEMO typu RT-08G X (umożliwiają czujnik drzwiczek)
export const NEMO_CONTROLLERS_RT08G_X = [
  'rt-08-g-x-wb',
  'rt-08-g-x-duo-integra',
  'rt-08-g-x-wb-duo-integra'
] as const

// Wszystkie sterowniki Dragon (wszystkie wymagają czujnika drzwiczek)
export const DRAGON_CONTROLLERS_ALL = [
  'rt-08-om',
  'rt-08-om-grafik',
  'rt-08-om-grafik-wb',
  'rt-08-om-duo-integra',
  'rt-08-om-grafik-duo-integra',
  'rt-08-om-grafik-duo-integra-wb'
] as const

// Funkcja sprawdzająca czy kontroler WYMAGA czujnika drzwiczek (nie można odhaczyć)
export function controllerRequiresDoorSensor(controllerId: string | undefined, isNemo: boolean): boolean {
  if (!controllerId || controllerId === 'none') return false
  
  if (isNemo) {
    // Dla NEMO: tylko RT-08GX wymaga czujnika
    return NEMO_CONTROLLERS_RT08G_X.includes(controllerId as any)
  } else {
    // Dla Dragon: wszystkie kontrolery wymagają czujnika
    return DRAGON_CONTROLLERS_ALL.includes(controllerId as any)
  }
}

// ====================================================================
// DRAGON - Obiekt gotowy do użycia w extraPrices
export const CONTROLLERS_EXTRA_PRICES = {
  'none': 0,
  'rt-08-om': 1510,
  'rt-08-om-grafik': 1610,
  'rt-08-om-grafik-wb': 1745,
  'rt-08-om-duo-integra': 2170,
  'rt-08-om-grafik-duo-integra': 2200,
  'rt-08-om-grafik-duo-integra-wb': 2300,
  'czujnik-drzwiczek': 215
}

// DRAGON - Obiekt gotowy do użycia w labels
export const CONTROLLERS_LABELS = {
  'none': 'Brak',
  'rt-08-om': 'RT-08 OM',
  'rt-08-om-grafik': 'RT-08 OM GRAFIK',
  'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
  'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
  'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
  'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK',
  'czujnik-drzwiczek': 'Czujnik drzwiczek'
}

// Sterowniki które wymagają wyboru koloru (white/black)
export const CONTROLLERS_WITH_COLOR = [
  'rt-08-om-grafik-wb',
  'rt-08-om-grafik-duo-integra-wb'
] as const

export type ControllerId = keyof typeof CONTROLLER_PRICES
export type ControllerColor = 'white' | 'black' | 'none'

// Funkcja sprawdzająca czy sterownik wymaga wyboru koloru
export function requiresColorSelection(controllerId: string | undefined): boolean {
  if (!controllerId) return false
  return CONTROLLERS_WITH_COLOR.includes(controllerId as any)
}

// Funkcja sprawdzająca czy sterownik NEMO wymaga wyboru koloru
export function nemoRequiresColorSelection(controllerId: string | undefined): boolean {
  if (!controllerId) return false
  return NEMO_CONTROLLERS_WITH_COLOR.includes(controllerId as any)
}

// Funkcja sprawdzająca czy sterownik NEMO wspiera opcję BUFOR
export function nemoSupportsBuffor(controllerId: string | undefined): boolean {
  if (!controllerId) return false
  return NEMO_CONTROLLERS_WITH_BUFOR.includes(controllerId as any)
}

// Funkcja sprawdzająca czy sterownik NEMO to RT-08G X (umożliwia czujnik drzwiczek)
export function nemoIsRT08GX(controllerId: string | undefined): boolean {
  if (!controllerId) return false
  return NEMO_CONTROLLERS_RT08G_X.includes(controllerId as any)
}

// Funkcja pobierająca pełną nazwę sterownika z kolorem
export function getControllerFullLabel(
  controllerId: string | undefined,
  color: ControllerColor = 'none'
): string {
  if (!controllerId || controllerId === 'none') return 'Brak'
  
  const baseLabel = CONTROLLER_LABELS[controllerId as ControllerId] || controllerId
  
  if (requiresColorSelection(controllerId) && color !== 'none') {
    const colorLabel = color === 'white' ? 'WHITE' : 'BLACK'
    return `${baseLabel.replace(' WHITE / BLACK', '')} ${colorLabel}`
  }
  
  return baseLabel
}

// Funkcja pobierająca pełną nazwę sterownika NEMO z kolorem i BUFOR
export function getNemoControllerFullLabel(
  controllerId: string | undefined,
  color: ControllerColor = 'none',
  isBuffor: boolean = false
): string {
  if (!controllerId || controllerId === 'none') return 'Brak'
  
  const baseLabel = NEMO_ALL_CONTROLLERS_LABELS[controllerId as keyof typeof NEMO_ALL_CONTROLLERS_LABELS] || controllerId
  
  let displayLabel = baseLabel
  
  // Dodaj kolor jeśli wymagany
  if (nemoRequiresColorSelection(controllerId) && color !== 'none') {
    const colorLabel = color === 'white' ? 'WHITE' : 'BLACK'
    displayLabel = baseLabel.replace(' WHITE / BLACK', '') + ' ' + colorLabel
  }
  
  // Dodaj BUFOR jeśli zaznaczony
  if (isBuffor && nemoSupportsBuffor(controllerId)) {
    displayLabel = displayLabel + ' BUFOR'
  }
  
  return displayLabel
}
